import * as React from 'react'
import { ColorPickerWidget } from './ColorPickerWidget'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ColorPickerWidgetExamples = () => {
  return (
    <div className="ColorPickerWidgetExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ColorPickerWidget />
      </Provider>
    </div>
  )
}
